import React, { useState } from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import VerifyInfoForm from './forms/VerifyInfoForm';
import ConfirmInfoForm from './forms/ConfirmInfoForm';
import CompleteSignUpForm from './forms/CompleteSignUpForm';


const steps = ['Verify info', 'Confirm contact', 'Complete sign up'];

const SignUpComponent = () => {
	const { regCode } = useParams();

	const [suStatus, setSUStatus] = useState({
		isCodePrefilled: !!regCode,
		regCode: regCode || '',
		lastName: '',
		dob: moment('1970-01-01'),
		address: '',
		address2: '',
		city: '',
		state: '',
		zip: '',
		method: 'text',
		receiver: ''
	})

	const [activeStep, setActiveStep] = useState(0);

	const handleReturn = async (values) => {
		await setSUStatus(prevState => ({
			...prevState,
			...values
		}))
		setActiveStep(activeStep + 1);
	};

	const handleBack = () => {
		setActiveStep(activeStep - 1);
	};

	const getStepContent = (step) => {
		switch (step) {
			case 0:
				return <VerifyInfoForm formState={suStatus} handleSubmit={handleReturn} />;
			case 1:
				return <ConfirmInfoForm formState={suStatus} handleSubmit={handleReturn} handleBack={handleBack} />;
			case 2:
				return <CompleteSignUpForm formState={suStatus} handleBack={handleBack}/>;
			default:
				throw new Error('Unknown step');
		}
	}

	return (
		<Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
			<Typography component="h1" variant="h4" align="center">
				Sign Up
			</Typography>
			<Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel>{label}</StepLabel>
					</Step>
				))}
			</Stepper>
			<React.Fragment>
				<Container maxWidth={"xs"}>
					{getStepContent(activeStep)}
				</Container>
			</React.Fragment>
		</Paper>
	)
}

export default SignUpComponent;